/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleDetails {
    getFixupPrototypeFunction() { return RoleDetails.fixupPrototype; }

    static newInstance(model: Partial<RoleDetails>): RoleDetails {
        let obj = Object.assign(new RoleDetails(), model);
        RoleDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleDetails>): RoleDetails {
        if (!model) return null;
        return RoleDetails.newInstance(<RoleDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleDetails) {
        if (!obj) return;

        models.RoleDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleDetails): boolean {
        Object.setPrototypeOf(obj, RoleDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.users === undefined) {
            this.users = 0;
        }
    }

    /**
     * ID of the Role. This is an auto generated and unique in the CoreStack system
     */
    id: string;

    /**
     * Tenant Id for the Role
     */
    tenant_id: string;

    /**
     * Name of the role. This is unique in the CoreStack system for a specific tenant
     */
    name: string;

    /**
     * Status of the Role
     */
    status: string;

    /**
     * List of access the role can perform in the tenant
     */
    access: Array<string>;

    /**
     * Count of users having the role attached under a tenant
     */
    users: number;

    /**
     * Description of the role
     */
    description: string;

    /**
     * Date and time of role creation
     */
    created_at: string;

    /**
     * Category of the specific role. Either default or custom
     */
    category: string;

    /**
     * List of policy available for a role
     */
    policies: any;

}
